import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { H1, Text } from '../components/ui/Typography';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { translations } from '../translations';

const Situations = () => {
  const { lang = 'nl' } = useParams();
  const t = translations[lang] || translations.nl;
  const s = t.situations;

  const situations = [
    { title: s.items.blended.title, icon: 'Users', desc: s.items.blended.desc, path: `/${lang}/${lang === 'nl' ? 'situaties/samengesteld-gezin' : 'situations/blended-family'}` },
    { title: s.items.entrepreneur.title, icon: 'Briefcase', desc: s.items.entrepreneur.desc, path: `/${lang}/${lang === 'nl' ? 'situaties/ondernemer' : 'situations/entrepreneur'}` },
    { title: s.items.international.title, icon: 'Globe', desc: s.items.international.desc, path: `/${lang}/${lang === 'nl' ? 'situaties/internationaal' : 'situations/international'}` },
    { title: s.items.unmarried.title, icon: 'Home', desc: s.items.unmarried.desc, path: `/${lang}/scan` },
    { title: s.items.digital.title, icon: 'HardDrive', desc: s.items.digital.desc, path: `/${lang}/scan` },
    { title: s.items.single.title, icon: 'User', desc: s.items.single.desc, path: `/${lang}/scan` },
  ];

  return (
    <div className="max-w-7xl mx-auto px-6 py-20">
      <div className="max-w-3xl mb-16">
        <H1 className="mb-6">{s.title}</H1>
        <Text>{s.subtitle}</Text>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {situations.map((sit, i) => (
          <Link to={sit.path} key={i}>
            <Card className="h-full p-8 hover:border-zinc-300 transition-colors cursor-pointer group">
              <div className="w-12 h-12 bg-zinc-50 rounded-xl flex items-center justify-center mb-6 text-navy-900 group-hover:scale-110 transition-transform">
                <SafeIcon name={sit.icon} className="text-xl" />
              </div>
              <h3 className="text-lg font-semibold mb-3 text-zinc-900">{sit.title}</h3>
              <Text subtle className="text-sm">{sit.desc}</Text>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Situations;